// extracted by mini-css-extract-plugin
export default {"TableView":"StockTable_TableView__oiNgc","Cell":"StockTable_Cell__HEuds","Paper":"StockTable_Paper__ZoOoR"};